module.exports = __webpack_public_path__ + "static/media/arc_ride.7342878e.webp";